/* ==========================================================================
   MAIMO 特集ページ セクション共通スクリプト

   ・機能情報DB（メタオブジェクト）を読み込み、機能名リンクからモーダル表示
   ・「動画を見る」の動画モーダル（デフォルト無音再生 / 閉じたら停止・再生位置を保持）
   ・商品画像スライダー（自動送り。ユーザー操作でページ内すべての自動送りを停止）
   ・SNSムービーのカルーセル（PC 5枚 / SP 2.5枚見せ。同上）

   自動送りは「画面に入ってから」始める。こうしないと、下のほうにある
   スライダーが見る前に進んでしまい、最初に1枚目が表示されない。

   各セクションから読み込まれるため二重実行になり得る。初期化は1回だけ行い、
   セクションの追加・並べ替え（テーマエディタ）にも追従できるようにしている。
   ========================================================================== */
(function () {
  'use strict';

  if (window.__maimoJourneyLoaded) return;
  window.__maimoJourneyLoaded = true;

  var FEATURES = {};
  var sliders = [];
  var carousels = [];
  var onBeforeClose = [];
  var lastFocused = null;

  /* ------------------------------------------------------------------
     機能情報DB
     各セクションが出力する <script class="mj-feature-db"> をすべて読み込む
     ------------------------------------------------------------------ */
  function loadFeatureDb() {
    var nodes = document.querySelectorAll('script.mj-feature-db');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.mjLoaded === '1') continue;
      nodes[i].dataset.mjLoaded = '1';
      try {
        var data = JSON.parse(nodes[i].textContent) || {};
        for (var key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) FEATURES[key] = data[key];
        }
      } catch (e) { /* 不正なJSONは無視する */ }
    }
  }

  /* ------------------------------------------------------------------
     モーダル（初回に1組だけ生成する）
     ------------------------------------------------------------------ */
  var featModal = null;
  var featPrev = null;
  var featNext = null;
  var featList = [];
  var featIdx = 0;
  var igModal = null;
  var igFrame = null;
  var igDemo = null;
  var igPrev = null;
  var igNext = null;
  var igList = [];
  var igIdx = 0;
  var videoModal = null;
  var videoEl = null;
  var videoEmpty = null;
  var videoDemo = null;
  var videoPrev = null;
  var videoNext = null;
  var videoPositions = {};
  var currentVideoSrc = '';
  var videoList = [];
  var videoIdx = 0;

  /* モーダルの閉じるボタン（グレーの下地を出さず、白い×だけにする） */
  var CLOSE_ICON = '<svg viewBox="0 0 40 40" aria-hidden="true" focusable="false">' +
    '<path d="M3 3 37 37 M37 3 3 37" fill="none" stroke="currentColor" stroke-width="2.5" ' +
    'stroke-linecap="round"/></svg>';

  /* モーダルの前後送りボタンの矢印 */
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M15.5 3.5 7 12l8.5 8.5" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildModals() {
    if (featModal) return;

    featModal = document.createElement('div');
    featModal.className = 'mj-modal mj-modal--feature';
    featModal.id = 'mj-feature-modal';
    featModal.hidden = true;
    featModal.innerHTML =
      '<div class="mj-modal__overlay"></div>' +
      '<button type="button" class="mj-modal__close" aria-label="閉じる">' + CLOSE_ICON + '</button>' +
      '<button type="button" class="mj-modal__nav mj-modal__nav--prev" aria-label="前の機能" hidden>' + ARROW + '</button>' +
      '<div class="mj-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="mj-feature-modal-title">' +
        '<div class="mj-modal__panel">' +
          '<img class="mj-modal__img" src="" alt="" width="1200" height="900">' +
          '<h3 class="mj-modal__title" id="mj-feature-modal-title"></h3>' +
          '<p class="mj-modal__text"></p>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="mj-modal__nav mj-modal__nav--next" aria-label="次の機能" hidden>' + ARROW + '</button>';

    videoModal = document.createElement('div');
    videoModal.className = 'mj-modal mj-modal--video';
    videoModal.id = 'mj-video-modal';
    videoModal.hidden = true;
    videoModal.innerHTML =
      '<div class="mj-modal__overlay"></div>' +
      '<button type="button" class="mj-modal__close" aria-label="閉じる">' + CLOSE_ICON + '</button>' +
      '<button type="button" class="mj-modal__nav mj-modal__nav--prev" aria-label="前の動画" hidden>' + ARROW + '</button>' +
      '<button type="button" class="mj-modal__nav mj-modal__nav--next" aria-label="次の動画" hidden>' + ARROW + '</button>' +
      '<div class="mj-modal__dialog" role="dialog" aria-modal="true" aria-label="商品動画">' +
        '<video class="mj-modal__video" playsinline muted controls preload="metadata"></video>' +
        '<p class="mj-modal__video-empty" hidden>動画が設定されていません。</p>' +
        '<p class="mj-modal__video-demo" hidden>動画（仮）<br>Liquid 版では Shopify のファイルから<br>選択した動画がここで再生されます。</p>' +
      '</div>';

    igModal = document.createElement('div');
    igModal.className = 'mj-modal mj-modal--ig';
    igModal.id = 'mj-instagram-modal';
    igModal.hidden = true;
    igModal.innerHTML =
      '<div class="mj-modal__overlay"></div>' +
      '<button type="button" class="mj-modal__close" aria-label="閉じる">' + CLOSE_ICON + '</button>' +
      '<button type="button" class="mj-modal__nav mj-modal__nav--prev" aria-label="前の投稿" hidden>' + ARROW + '</button>' +
      '<div class="mj-modal__dialog" role="dialog" aria-modal="true" aria-label="Instagramの投稿">' +
        '<iframe class="mj-modal__ig" title="Instagramの投稿" src="" scrolling="no" ' +
          'allow="encrypted-media; picture-in-picture; web-share" allowfullscreen></iframe>' +
        '<p class="mj-modal__ig-demo" hidden>Instagram投稿（仮）<br>Liquid 版では、設定した投稿の<br>公式埋め込みがここに表示されます。</p>' +
      '</div>' +
      '<button type="button" class="mj-modal__nav mj-modal__nav--next" aria-label="次の投稿" hidden>' + ARROW + '</button>';

    document.body.appendChild(featModal);
    document.body.appendChild(igModal);
    document.body.appendChild(videoModal);

    featPrev = featModal.querySelector('.mj-modal__nav--prev');
    featNext = featModal.querySelector('.mj-modal__nav--next');

    featPrev.addEventListener('click', function (ev) {
      ev.stopPropagation();
      showFeatureAt(featIdx - 1);
    });
    featNext.addEventListener('click', function (ev) {
      ev.stopPropagation();
      showFeatureAt(featIdx + 1);
    });

    igFrame = igModal.querySelector('.mj-modal__ig');
    igDemo = igModal.querySelector('.mj-modal__ig-demo');
    igPrev = igModal.querySelector('.mj-modal__nav--prev');
    igNext = igModal.querySelector('.mj-modal__nav--next');

    igPrev.addEventListener('click', function (ev) {
      ev.stopPropagation();
      showIgAt(igIdx - 1);
    });
    igNext.addEventListener('click', function (ev) {
      ev.stopPropagation();
      showIgAt(igIdx + 1);
    });

    /* Instagram の埋め込みは、中身の高さを親ウィンドウへ知らせてくる。
       投稿（縦長・正方形・キャプションの量）で必要な高さが変わるため、
       決め打ちにせず受け取った高さに合わせる。画面に収まらない分は
       ダイアログ側のスクロールで見てもらう */
    window.addEventListener('message', function (ev) {
      if (!igFrame || igFrame.hidden) return;
      if (String(ev.origin).indexOf('instagram.com') === -1) return;
      if (ev.source !== igFrame.contentWindow) return;

      var data = ev.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return; }
      }
      if (!data || data.type !== 'MEASURE' || !data.details || !data.details.height) return;
      igFrame.style.height = data.details.height + 'px';
    });

    // 閉じたら埋め込みを破棄する（そのままだと裏で再生が続く）
    onBeforeClose.push(function (modal) {
      if (modal !== igModal || !igFrame) return;
      igFrame.removeAttribute('src');
    });

    videoEl = videoModal.querySelector('.mj-modal__video');
    videoEmpty = videoModal.querySelector('.mj-modal__video-empty');
    videoDemo = videoModal.querySelector('.mj-modal__video-demo');
    videoPrev = videoModal.querySelector('.mj-modal__nav--prev');
    videoNext = videoModal.querySelector('.mj-modal__nav--next');

    videoPrev.addEventListener('click', function (ev) {
      ev.stopPropagation();
      playAt(videoIdx - 1);
    });
    videoNext.addEventListener('click', function (ev) {
      ev.stopPropagation();
      playAt(videoIdx + 1);
    });

    // 閉じる直前に動画を停止し、再生位置を覚えておく（次回は途中から再生）
    onBeforeClose.push(function (modal) {
      if (modal !== videoModal || !videoEl || videoEl.hidden) return;
      if (currentVideoSrc) videoPositions[currentVideoSrc] = videoEl.currentTime;
      videoEl.pause();
    });
  }

  function openModal(modal) {
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('mj-modal-open');
    var closeBtn = modal.querySelector('.mj-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    onBeforeClose.forEach(function (fn) { fn(modal); });
    modal.hidden = true;
    if (!document.querySelector('.mj-modal:not([hidden])')) {
      document.body.classList.remove('mj-modal-open');
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  /* モーダル内のクリックは、中央のコンテンツ以外ならすべて閉じる
     （右上の × ボタン・黒い半透明の背景のどちらでも閉じる） */
  var MODAL_CONTENT = '.mj-modal__panel, .mj-modal__video, .mj-modal__video-empty,' +
    ' .mj-modal__video-demo, .mj-modal__ig, .mj-modal__ig-demo, .mj-modal__nav';

  document.addEventListener('click', function (ev) {
    var modal = ev.target.closest('.mj-modal');
    if (!modal || modal.hidden) return;
    if (ev.target.closest(MODAL_CONTENT)) return;
    closeModal(modal);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var open = document.querySelector('.mj-modal:not([hidden])');
    if (open) closeModal(open);
  });

  /* ------------------------------------------------------------------
     機能説明モーダル
     ------------------------------------------------------------------ */
  /* 一覧の i 番目の機能を表示する（端まで来たら反対側へ回る） */
  function showFeatureAt(i) {
    if (!featList.length) return;
    featIdx = (i + featList.length) % featList.length;

    var data = FEATURES[featList[featIdx]];
    if (!data) return;

    var img = featModal.querySelector('.mj-modal__img');
    if (data.modal_image) {
      img.src = data.modal_image;
      img.alt = data.name || '';
      img.hidden = false;
    } else {
      img.removeAttribute('src');
      img.hidden = true;
    }
    featModal.querySelector('.mj-modal__title').textContent = data.name || '';
    featModal.querySelector('.mj-modal__text').textContent = data.description || '';

    var many = featList.length > 1;
    featPrev.hidden = !many;
    featNext.hidden = !many;
  }

  /* 押されたセルから、同じ機能表に並ぶ機能をまとめて一覧にする。
     ON / OFF は問わず、セクション設定で選んだ並び順のまま前後に送れる。
     機能表の外（比較表など）から開いたときは、その機能だけを表示する */
  function openFeatureFrom(trigger) {
    loadFeatureDb();

    var key = trigger.getAttribute('data-mj-feature');
    if (!FEATURES[key]) return;
    buildModals();

    var table = trigger.closest('[data-mj-features]');
    var start = 0;
    featList = [];

    if (table) {
      var cells = table.querySelectorAll('[data-mj-feature-key]');
      for (var i = 0; i < cells.length; i++) {
        var k = cells[i].getAttribute('data-mj-feature-key');
        if (!FEATURES[k]) continue;   // 説明のない機能は送り先にしない
        if (k === key) start = featList.length;
        featList.push(k);
      }
    }
    if (!featList.length) featList = [key];

    showFeatureAt(start);
    openModal(featModal);
  }

  /* ------------------------------------------------------------------
     動画モーダル
     ------------------------------------------------------------------ */
  /* いま流している動画の再生位置を覚えておく */
  function saveVideoPos() {
    if (videoEl && !videoEl.hidden && currentVideoSrc) {
      videoPositions[currentVideoSrc] = videoEl.currentTime;
    }
  }

  function showVideo(src, demo) {
    saveVideoPos();

    if (demo) {
      // HTML プレビュー専用：動画の仮表示
      videoEl.pause();
      videoEl.hidden = true;
      videoEmpty.hidden = true;
      videoDemo.hidden = false;
      return;
    }
    if (!src) {
      videoEl.pause();
      videoEl.hidden = true;
      videoDemo.hidden = true;
      videoEmpty.hidden = false;
      return;
    }

    videoDemo.hidden = true;
    videoEmpty.hidden = true;
    videoEl.hidden = false;

    if (currentVideoSrc !== src) {
      videoEl.src = src;
      currentVideoSrc = src;
    }
    videoEl.muted = true;
    videoEl.currentTime = videoPositions[src] || 0;
    var p = videoEl.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* 自動再生が拒否された場合は何もしない */ });
  }

  /* プレイリストの i 番目を再生する（端まで来たら反対側へ回る） */
  function playAt(i) {
    if (!videoList.length) return;
    videoIdx = (i + videoList.length) % videoList.length;
    var many = videoList.length > 1;
    videoPrev.hidden = !many;
    videoNext.hidden = !many;
    showVideo(videoList[videoIdx].src, videoList[videoIdx].demo);
  }

  /* 押されたボタンから、同じグループ内の動画をまとめてプレイリストにする */
  function openVideoFrom(trigger) {
    buildModals();
    stopAll();            // 動画を開くのもユーザー操作なので自動送りは止める

    var group = trigger.closest('[data-mj-group]');
    var start = 0;
    videoList = [];

    if (group) {
      var btns = group.querySelectorAll('[data-mj-video]');
      for (var i = 0; i < btns.length; i++) {
        videoList.push({
          src: btns[i].getAttribute('data-mj-video'),
          demo: btns[i].hasAttribute('data-mj-video-demo')
        });
        if (btns[i] === trigger) start = i;
      }
    }
    if (!videoList.length) {
      videoList = [{
        src: trigger.getAttribute('data-mj-video'),
        demo: trigger.hasAttribute('data-mj-video-demo')
      }];
    }

    openModal(videoModal);
    playAt(start);
  }

  /* ------------------------------------------------------------------
     Instagram 埋め込みモーダル
     公式の埋め込み（iframe）をそのまま開く。再生は埋め込み内の再生ボタンで
     行うため、自動再生・再生位置の保持・前後送りはできない
     ------------------------------------------------------------------ */
  /* 一覧の i 番目の投稿を表示する（端まで来たら反対側へ回る）
     切り替えるたびに埋め込みを読み込み直すため、再生は毎回押し直しになる */
  function showIgAt(i) {
    if (!igList.length) return;
    igIdx = (i + igList.length) % igList.length;

    var item = igList[igIdx];
    if (item.demo) {
      // HTML プレビュー専用：埋め込みの仮表示
      igFrame.removeAttribute('src');
      igFrame.hidden = true;
      igDemo.hidden = false;
    } else {
      igDemo.hidden = true;
      igFrame.hidden = false;
      igFrame.style.height = '';   // 前の投稿の高さを引きずらないよう戻す
      igFrame.src = item.src;
    }

    var many = igList.length > 1;
    igPrev.hidden = !many;
    igNext.hidden = !many;
  }

  /* 押されたタイルから、同じブロック内の投稿をまとめて一覧にする */
  function openInstagramFrom(trigger) {
    buildModals();
    stopAll();            // モーダルを開くのもユーザー操作なので自動送りは止める

    var group = trigger.closest('[data-mj-group]');
    var start = 0;
    igList = [];

    if (group) {
      var tiles = group.querySelectorAll('[data-mj-instagram]');
      for (var i = 0; i < tiles.length; i++) {
        igList.push({
          src: tiles[i].getAttribute('data-mj-instagram'),
          demo: tiles[i].hasAttribute('data-mj-ig-demo')
        });
        if (tiles[i] === trigger) start = i;
      }
    }
    if (!igList.length) {
      igList = [{
        src: trigger.getAttribute('data-mj-instagram'),
        demo: trigger.hasAttribute('data-mj-ig-demo')
      }];
    }

    openModal(igModal);
    showIgAt(start);
  }

  document.addEventListener('click', function (ev) {
    var feat = ev.target.closest('[data-mj-feature]');
    if (feat) {
      ev.preventDefault();
      openFeatureFrom(feat);
      return;
    }
    var insta = ev.target.closest('[data-mj-instagram]');
    if (insta) {
      ev.preventDefault();
      openInstagramFrom(insta);
      return;
    }
    var video = ev.target.closest('[data-mj-video]');
    if (video) {
      ev.preventDefault();
      openVideoFrom(video);
    }
  });

  /* ------------------------------------------------------------------
     商品画像スライダー
     data-mj-slider   … スライダー本体
     data-mj-interval … 自動送りの間隔（ミリ秒）

     ユーザーが操作したスライダーは、そのスライダーだけ自動送りを停止する。
     操作していない他のスライダーは、画面に入ったときの自動送りを続ける。
     ------------------------------------------------------------------ */
  function Slider(el) {
    this.el = el;
    this.track = el.querySelector('.mj-slider__track');
    this.slides = Array.prototype.slice.call(el.querySelectorAll('.mj-slider__slide'));
    this.dots = Array.prototype.slice.call(
      (el.parentNode.querySelector('.mj-dots') || el).querySelectorAll('.mj-dots__dot')
    );
    // 枚数が多いスライダーはドットの代わりに「1 / 21」のカウンターを出している
    this.counter = el.parentNode
      ? el.parentNode.querySelector('[data-mj-counter-current]')
      : null;
    this.index = 0;
    this.timer = null;
    this.interval = parseInt(el.getAttribute('data-mj-interval'), 10) || 3000;

    this.inView = false;
    this.userStopped = false;   // このスライダーが操作されたか

    if (this.slides.length > 1) {
      this.bind();
      observeAutoplay(this);   // 画面に入ったら start() が呼ばれる
    }
  }

  Slider.prototype.go = function (i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.track.style.transform = 'translateX(' + (-100 * this.index) + '%)';
    this.dots.forEach(function (dot, di) {
      dot.setAttribute('aria-current', di === this.index ? 'true' : 'false');
    }, this);
    if (this.counter) this.counter.textContent = this.index + 1;
  };

  Slider.prototype.start = function () {
    if (!autoplayOn || this.userStopped || !this.inView) return;
    var self = this;
    this.stop();
    this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval);
  };

  Slider.prototype.stop = function () {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  };

  /* 操作されたスライダーだけ、以降は画面に入っても自動送りを再開しない */
  Slider.prototype.stopByUser = function () {
    this.userStopped = true;
    this.stop();
  };

  Slider.prototype.bind = function () {
    var self = this;

    // ドット操作
    this.dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () {
        self.stopByUser();
        self.go(di);
      });
    });

    // スワイプ / ドラッグ操作（タッチ・マウス共通）
    var startX = null;
    var onDown = function (ev) {
      startX = (ev.touches ? ev.touches[0] : ev).clientX;
    };
    var onUp = function (ev) {
      if (startX === null) return;
      var x = (ev.changedTouches ? ev.changedTouches[0] : ev).clientX;
      var dx = x - startX;
      startX = null;
      if (Math.abs(dx) < 30) return;
      self.stopByUser();
      self.go(self.index + (dx < 0 ? 1 : -1));
    };
    this.el.addEventListener('touchstart', onDown, { passive: true });
    this.el.addEventListener('touchend', onUp);
    this.el.addEventListener('mousedown', onDown);
    this.el.addEventListener('mouseup', onUp);
    this.el.addEventListener('mouseleave', function () { startX = null; });
    // 画像のドラッグ（ゴースト表示）を抑止する
    this.el.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
  };

  /* 動画・Instagram のモーダルを開いたときだけ、ページ内すべての自動送りを止める。
     スライダー／カルーセルの操作は、操作した本人（stopByUser）だけが止まる。 */
  var autoplayOn = true;

  function stopAll() {
    autoplayOn = false;
    sliders.forEach(function (s) { s.stop(); });
    carousels.forEach(function (c) { c.stop(); });
  }

  /* 画面に入ったら自動送りを開始し、外れたら止める。
     見る前に進んでしまうのを防ぐため、最初に見えた時点では必ず1枚目のまま。 */
  var autoObserver = null;

  function observeAutoplay(obj) {
    if (typeof IntersectionObserver === 'undefined') {
      obj.inView = true;          // 非対応の環境では従来どおりすぐ開始する
      obj.start();
      return;
    }
    if (!autoObserver) {
      autoObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var o = entries[i].target.mjAutoplay;
          if (!o) continue;
          o.inView = entries[i].isIntersecting;
          if (o.inView) o.start(); else o.stop();
        }
      }, { threshold: 0.2 });
    }
    obj.el.mjAutoplay = obj;
    autoObserver.observe(obj.el);
  }

  /* ------------------------------------------------------------------
     SNSムービーのカルーセル
     data-mj-carousel … カルーセルの表示枠（overflow:hidden）
     data-mj-interval … 自動送りの間隔（ミリ秒）

     1枚ずつ横にずらす。1画面に見せる枚数は CSS 側で決めており
     （PC 5枚 / SP 2.5枚）、JS は実寸から送り幅とページ数を求める。
     表示枠の外にははみ出さないので、画面に横スクロールは出ない。
     ------------------------------------------------------------------ */
  function Carousel(el) {
    this.el = el;
    this.track = el.querySelector('.mj-sns__track');
    this.items = Array.prototype.slice.call(el.querySelectorAll('.mj-sns__tile'));
    this.dotsWrap = el.parentNode ? el.parentNode.querySelector('.mj-sns__dots') : null;
    this.dots = [];
    this.index = 0;
    this.pages = 1;
    this.pitch = 0;
    this.max = 0;
    this.timer = null;
    this.dragged = false;
    this.interval = parseInt(el.getAttribute('data-mj-interval'), 10) || 3000;
    this.inView = false;
    this.userStopped = false;   // このカルーセルが操作されたか

    if (this.items.length > 1) {
      this.bind();
      this.layout();
      observeAutoplay(this);   // 画面に入ったら start() が呼ばれる
    }
  }

  /* 実寸から「1枚ずらす幅」「動かせる最大量」「ページ数」を求める */
  Carousel.prototype.measure = function () {
    var a = this.items[0].getBoundingClientRect();
    var b = this.items[1] ? this.items[1].getBoundingClientRect() : null;
    this.pitch = b ? Math.round(b.left - a.left) : Math.round(a.width);
    this.max = Math.max(0, this.track.scrollWidth - this.el.clientWidth);
    this.pages = this.pitch > 0 ? Math.ceil(this.max / this.pitch) + 1 : 1;
  };

  Carousel.prototype.layout = function () {
    this.measure();
    if (this.pitch <= 0) return;          // 非表示のときは何もしない
    this.buildDots();
    if (this.pages < 2) this.stop();
    this.go(Math.min(this.index, this.pages - 1), true);
  };

  Carousel.prototype.buildDots = function () {
    if (!this.dotsWrap) return;
    if (this.dots.length === this.pages) return;   // ページ数が変わったときだけ作り直す
    var self = this;
    this.dotsWrap.textContent = '';
    this.dots = [];
    if (this.pages < 2) return;
    for (var i = 0; i < this.pages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mj-dots__dot';
      dot.setAttribute('aria-label', (i + 1) + 'ページ目');
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      dot.addEventListener('click', (function (di) {
        return function () { self.stopByUser(); self.go(di); };
      })(i));
      this.dotsWrap.appendChild(dot);
      this.dots.push(dot);
    }
  };

  Carousel.prototype.go = function (i, instant) {
    var last = this.pages - 1;
    this.index = i < 0 ? last : (i > last ? 0 : i);
    var shift = Math.min(this.index * this.pitch, this.max);

    if (instant) this.track.style.transition = 'none';
    this.track.style.transform = 'translateX(' + (-shift) + 'px)';
    if (instant) {
      void this.track.offsetWidth;               // 位置を確定させてから戻す
      this.track.style.transition = '';
    }
    for (var d = 0; d < this.dots.length; d++) {
      this.dots[d].setAttribute('aria-current', d === this.index ? 'true' : 'false');
    }
  };

  Carousel.prototype.start = function () {
    if (this.pages < 2 || !autoplayOn || this.userStopped || !this.inView) return;
    var self = this;
    this.stop();
    this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval);
  };

  Carousel.prototype.stop = function () {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  };

  /* 操作されたカルーセルだけ、以降は画面に入っても自動送りを再開しない */
  Carousel.prototype.stopByUser = function () {
    this.userStopped = true;
    this.stop();
  };

  Carousel.prototype.bind = function () {
    var self = this;
    var startX = null;

    var onDown = function (ev) {
      startX = (ev.touches ? ev.touches[0] : ev).clientX;
    };
    var onUp = function (ev) {
      if (startX === null) return;
      var x = (ev.changedTouches ? ev.changedTouches[0] : ev).clientX;
      var dx = x - startX;
      startX = null;
      if (Math.abs(dx) < 30) return;
      self.dragged = true;                       // 直後のクリックは無視する
      self.stopByUser();
      self.go(self.index + (dx < 0 ? 1 : -1));
    };

    this.el.addEventListener('touchstart', onDown, { passive: true });
    this.el.addEventListener('touchend', onUp);
    this.el.addEventListener('mousedown', onDown);
    this.el.addEventListener('mouseup', onUp);
    this.el.addEventListener('mouseleave', function () { startX = null; });
    this.el.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

    // ドラッグでスライドしたときに動画モーダルが開かないようにする
    this.el.addEventListener('click', function (ev) {
      if (!self.dragged) return;
      self.dragged = false;
      ev.preventDefault();
      ev.stopPropagation();
    }, true);
  };

  function initCarousels() {
    var els = document.querySelectorAll('[data-mj-carousel]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].dataset.mjInit === '1') continue;
      els[i].dataset.mjInit = '1';
      carousels.push(new Carousel(els[i]));
    }
  }

  /* 画面幅が変わると1画面の枚数（PC 5 / SP 2.5）が変わるので測り直す */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      carousels.forEach(function (c) { if (c.items.length > 1) c.layout(); });
    }, 150);
  });

  function initSliders() {
    var els = document.querySelectorAll('[data-mj-slider]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].dataset.mjInit === '1') continue;
      els[i].dataset.mjInit = '1';
      sliders.push(new Slider(els[i]));
    }
  }

  /* ------------------------------------------------------------------
     口コミ評価（Judge.me Review Widget）
     デザインではサマリーに平均点を大きく出すが、Judge.me は数値を単体で
     出力していないため、既にある aria-label（例: "Average rating is 4.83
     stars"）から読み取って追加する。カラーコードのような手入力は不要。
     ウィジェットは後から描画されるので、追加されたら差し込む。
     ------------------------------------------------------------------ */
  function addReviewScore(scope) {
    var inners = scope.querySelectorAll('.jdgm-rev-widg__summary-inner');
    for (var i = 0; i < inners.length; i++) {
      if (inners[i].querySelector('.mj-jdgm-score')) continue;
      var stars = inners[i].querySelector('.jdgm-rev-widg__summary-stars');
      if (!stars) continue;
      var label = stars.getAttribute('aria-label') || '';
      var m = label.match(/[0-9]+[.][0-9]+/) || label.match(/[0-9]+/);
      if (!m) continue;
      var el = document.createElement('span');
      el.className = 'mj-jdgm-score';
      el.textContent = (Math.round(parseFloat(m[0]) * 10) / 10).toFixed(1);
      inners[i].insertBefore(el, inners[i].firstChild);
    }
  }

  /* 並べ替えと口コミリストを1つの箱にまとめる。
     こうしないとPCの2カラム（左リスト / 右サマリー）で行が引き伸ばされる */
  function groupReviewColumns(scope) {
    var widgets = scope.querySelectorAll('.jdgm-rev-widg');
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      if (w.querySelector(':scope > .mj-jdgm-main')) continue;
      var body = w.querySelector(':scope > .jdgm-rev-widg__body');
      if (!body) continue;
      var main = document.createElement('div');
      main.className = 'mj-jdgm-main';
      w.insertBefore(main, body);
      var actions = w.querySelector(':scope > .jdgm-row-actions');
      if (actions) main.appendChild(actions);
      main.appendChild(body);
    }
  }

  function initReviewWidgets() {
    var wraps = document.querySelectorAll('.mj-pdsec__item--app');
    for (var i = 0; i < wraps.length; i++) {
      groupReviewColumns(wraps[i]);
      addReviewScore(wraps[i]);
      if (wraps[i].dataset.mjInit === '1') continue;
      wraps[i].dataset.mjInit = '1';
      (function (wrap) {
        var timer = null;
        new MutationObserver(function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            groupReviewColumns(wrap);
            addReviewScore(wrap);
          }, 100);
        }).observe(wrap, { childList: true, subtree: true });
      })(wraps[i]);
    }
  }

  function init() {
    loadFeatureDb();
    initSliders();
    initCarousels();
    initReviewWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* テーマエディタでセクションを追加・編集したときに再初期化する */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    var alive = function (s) {
      if (document.body.contains(s.el)) return true;
      s.stop();
      if (autoObserver) autoObserver.unobserve(s.el);
      return false;
    };
    sliders = sliders.filter(alive);
    carousels = carousels.filter(alive);
  });
})();
